module.exports = __webpack_public_path__ + "img/sua-morinaga.a43bd827.jpg";